/**
 * NotFoundPage — catch-all 404 for any unmatched SPA path.
 *
 * Before this existed, App.tsx had no `path="*"` route, so an unknown URL matched
 * nothing and React Router rendered an empty tree → blank `#root` (white screen).
 * This page guarantees a real, chrome-wrapped screen for every path and gives the
 * visitor a way back (Orders) plus a link to the public Stock site.
 */
import { Link } from 'react-router-dom';
import { PublicShell } from '../components/layout/PublicShell';
import { BRAND } from '../components/layout/designTokens';
import { STOCK_HREF } from '../components/chrome/chromeNav';

export function NotFoundPage(): JSX.Element {
  return (
    <PublicShell>
      <div
        style={{
          maxWidth: '32rem',
          margin: '0 auto',
          padding: '0 1.5rem',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <p style={{ margin: 0, fontSize: '0.875rem', fontWeight: 600, color: BRAND.slate500 }}>
          404
        </p>
        <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700, color: BRAND.navy900 }}>
          Page not found
        </h1>
        <p style={{ margin: 0, color: BRAND.slate700 }}>
          The page you are looking for doesn’t exist or has moved.
        </p>
        <div
          style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}
        >
          <Link
            to="/orders"
            style={{
              border: `1px solid ${BRAND.navy700}`,
              borderRadius: '0.375rem',
              background: BRAND.navy700,
              color: BRAND.white,
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >
            Go to Orders
          </Link>
          <a
            href={STOCK_HREF}
            style={{
              border: `1px solid ${BRAND.slate300}`,
              borderRadius: '0.375rem',
              background: BRAND.white,
              color: BRAND.navy900,
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              textDecoration: 'none',
            }}
          >
            Browse Stock
          </a>
        </div>
      </div>
    </PublicShell>
  );
}
